import { gql } from '@apollo/client';
import { communityImageCardFragment } from '@src/components/CommunityImageCard/CommunityImageCard.fragment';

export const carouselBlockFragment = gql`
  fragment carouselBlock on CarouselBlock {
    __typename
    sys {
      ...sys
    }
    tagline
    heading
    description
    carouselItemsCollection(limit: 7) {
      items {
        ...communityImageCard
      }
    }
  }

  ${communityImageCardFragment}
`;
